import { SelectOption } from "@/types/inputField"

export enum FieldMap {
  SOURCE = 'sourceField',
  DESTINATION = 'destinationField',
  OPTIONS = 'options'
}

export enum WorkflowRunType {
  SCHEDULED = 'scheduled',
  MANUAL = 'manual'
}

export enum AvailableScheduleTypes {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
  YEARLY = 'Yearly'
}

export const FormattedScheduledType = {
  [AvailableScheduleTypes.DAILY]: 'Day',
  [AvailableScheduleTypes.WEEKLY]: 'Week',
  [AvailableScheduleTypes.MONTHLY]: 'Month',
  [AvailableScheduleTypes.YEARLY]: 'Year',
}

export const AvailableWorkflowTriggerTime = [
  '12:00 AM',
  '3:00 AM',
  '6:00 AM',
  '9:00 AM',
  '12:00 PM',
  '3:00 PM',
  '6:00 PM',
  '9:00 PM'
]

export enum WeekDays {
  SUNDAY = 'Sunday',
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
  SATURDAY = 'Saturday'
}

export enum Months {
  JANUARY = 'January',
  FEBRUARY = 'February',
  MARCH = 'March',
  APRIL = 'April',
  MAY = 'May',
  JUNE = 'June',
  JULY = 'July',
  AUGUST = 'August',
  SEPTEMBER = 'September',
  OCTOBER = 'October',
  NOVEMBER = 'November',
  DECEMBER = 'Saturday',
}

export enum TransformationStepType {
  GROUP_AND_AGGREGATE = 'GROUP_AND_AGGREGATE',
  MAP_OBJECTS = 'MAP_OBJECTS',
  FANOUT = 'FANOUT',
  FLATTEN_ARRAY_FIELDS = 'FLATTEN_ARRAY_FIELDS',
  ADD_NEW_FIELDS = 'ADD_NEW_FIELDS'
}

export enum AppFieldsType {
  REQUEST_TYPE = 'requestFields',
  RESPONSE_TYPE = 'responseFields'
}

export enum WorkflowStepType {
  APP_BASED = 'app_based',
  TRANSFORMATION = 'transformation'
}

export const CampArrayFieldOptions: SelectOption[] = [
  { id: 'campers', value: 'Campers' },
  { id: 'parents', value: 'Parents' }
]
